export const LEGACY_DEAL_AMOUNT_CALCULATION = 'legacy-deal-amount-calculation';